export enum SocialNetwork {
  Facebook = 'Facebook',
  Linkedin = 'Linkedin',
  Youtube = 'Youtube',
  TikTok = 'TikTok',
  X = 'X',
}
